import qs from './qs';
import {memoize, always, compose} from 'ramda';

const qsc = compose(always, memoize(qs));

export default qsc;



/** WEBPACK FOOTER **
 ** ./app/scripts/util/dom/qsc.js
 **/